import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import {useParams,useLocation} from "react-router-dom"
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Button, Modal, Form, Col, Row} from "react-bootstrap";
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import {requestAPI} from '../services'
import {useMobxState} from "../mobx/global-context";
import thLocale from '@fullcalendar/core/locales/th';
import TimePicker from 'react-time-picker';
import {toast} from "react-toastify";
import {CgSandClock} from "react-icons/cg";
import {BsCheckAll} from "react-icons/bs";
import pkg from '../../package.json';
import {confirmAlert} from 'react-confirm-alert'; // Import

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Booking = () => {
    let query = useQuery();
    const [room, setRoom] = useState([])
    const [currentRoom, setCurrentRoom] = useState()
    const [reason, setReason] = useState([])
    const [show, setShow] = useState(false)
    const [events, setEvents] = useState([])
    const [activity,setActivity] = useState('');
    const [contact,setContact] = useState('');
    const [description,setDescription] = useState('');
    const [selectedReason, setSelectedReason] = useState("none");
    const state = useMobxState();
    const [currentDate, setCurrentDate] = useState();
    const [timeStart, setTimeStart] = useState('08:30');
    const [timeEnd, setTimeEnd] = useState('16:30');
    let {id} = useParams();

    function getBooking(){
        // requestAPI('POST')
        // booking
        axios.get(pkg.api_url+'/bookings?_limit=-1&_where[0][booking_room.id]=' + id).then((res)=>{
            let d = res.data
            let event_tmp = [];
            d.map((booking)=>{
                let startT = moment(booking.startTime,'HH:mm:ss').format('HH:mm')
                let endT = moment(booking.endTime,'HH:mm:ss').format('HH:mm')
                let between = startT + '-' + endT
                let bgColor,borderColor,textColor;
                if(state.currentUser.id==booking.booking_user.id){
                    if(booking.booking_status.id == 3){
                        bgColor = '#efe22c';
                        borderColor = '#cabb1d';
                        textColor = '#000000';
                    }else if(booking.booking_status.id == 1){
                        bgColor = '#57c128';
                        borderColor = '#469d1a';
                        textColor = '#ffffff';
                    }
                }else{
                    bgColor = '#c6c6c6';
                    borderColor = '#a5a7a5';
                    textColor = '#737272';
                }

                event_tmp.push({
                    id:booking.id,
                    title:between + ' ' + booking.nameActivity,
                    infoEvent: booking.nameActivity,
                    infoUser: booking.booking_user.username,
                    start:booking.startDate,
                    allDay:true,
                    backgroundColor: bgColor,
                    borderColor: borderColor,
                    textColor: textColor,
                    statusID:booking.booking_status.id,
                    otherUser:!(state.currentUser.id == booking.booking_user.id)
                });
            })
            setEvents(event_tmp);
        })
    }

    useEffect(() => {
        // reason
        axios.get(pkg.api_url+'/reasons').then((res)=>{
            let d = res.data
            setReason(d);
        })

        axios.get(pkg.api_url+'/rooms').then((res)=>{
            let d = res.data
            let thisRoom = d.find(r=>r.id==id);
            setCurrentRoom(thisRoom);
            //console.log('thisRoom=====',thisRoom);
            setRoom(d);
        })

        let t = query.get('t');
        if(t){
            try{
                let tDate=new Date(parseInt(t,10));
                let dDiff = moment().diff(tDate,'days');
                // if(dDiff==0){
                setTimeStart(moment(tDate).format('HH:mm'));
                // setTimeEnd(moment(tDate).add('3','hours').format('HH:mm'));
                setShow(true)
                setCurrentDate(tDate)
                // }
            }catch(e){
                console.log(e.message);
            }
        }
        getBooking();
    }, [])


    function handleDateClick(event) {
        setShow(true)
        setCurrentDate(event.date)
    }
    function submit(e){
        e.preventDefault();
        console.log(activity,selectedReason)
        requestAPI('POST','/bookings',{
            //"booking_user": state.currentUser.id,
            "booking_room": id,
            "startDate": moment(currentDate).format('YYYY-MM-DD'),
            "startTime": timeStart + ':00',
            "endTime": timeEnd + ':00',
            "nameActivity": activity,
            "contact": contact,
            "description": description,
            "booking_reason": selectedReason,
            "booking_status": 3,
        }).then(data=>{
            console.log(data);
            if(!data.error){
                toast.success('การจองของคุณสำเร็จ');
                setShow(false)
                getBooking();
            }else{
                toast.error(data.message);
            }
        }).catch((e)=>{
            console.log('================',e.data);
            toast.error('การจองของคุณไม่สำเร็จ');
        })
    }
    return (
        <div>
            <div>
                <Row className="mt-4 mb-3">
                    <Col>
                        <h3>{room.find((room)=>room.id==id)?.name}</h3>
                    </Col>
                    <Col>
                        <Row>
                            <Col><div style={{background:'#EFE22C',borderRadius:5,padding:3,textAlign:'center',whiteSpace:'nowrap'}}><CgSandClock/> Pending</div></Col>
                            <Col><div style={{background:'#57C128',borderRadius:5,padding:3,textAlign:'center',whiteSpace:'nowrap'}}><BsCheckAll/> Approved</div></Col>
                            <Col><div style={{background:'#c6c6c6',borderRadius:5,padding:3,textAlign:'center',whiteSpace:'nowrap'}}> Other booking </div></Col>
                        </Row>
                    </Col>
                </Row>

                {/*Calendar*/}
                <FullCalendar
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    hiddenDays = {[0,6]}
                    weekends = {false}

                    headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,dayGridWeek,dayGridDay',
                    }}

                    /*pop-up detail booking*/
                    dateClick={handleDateClick}
                    eventClick={(info)=>{
                        console.log(info);
                        if(info.event.extendedProps.otherUser)return;
                        confirmAlert({
                            title: 'Confirm to delete',
                            message: 'คุณต้องการยกเลิกการจองห้องในเวลา ' + info.event.title + ' ใช่หรือไม่ ?',
                            buttons: [
                                {
                                    label: 'Yes',
                                    onClick:async () => {
                                        try{
                                            await requestAPI('DELETE','/bookings/'+info.event?.id);
                                            getBooking();
                                            toast.success('ยกเลิกการจองของคุณสำเร็จ')
                                        }catch(e){
                                            toast.error('ยกเลิกการจองของคุณไม่สำเร็จ')
                                        }
                                    }
                                },
                                {
                                    label: 'No',
                                }
                            ]
                        });
                    }}
                    events={events}
                    locale={thLocale}
                    eventContent={(arg)=>{
                        let strTip=`กิจกรรม : ${arg.event.extendedProps.infoEvent} <br/> ผู้จอง : ${arg.event.extendedProps.infoUser}`;
                        if(arg.event.extendedProps.otherUser){
                            strTip=`กิจกรรม : ${arg.event.extendedProps.infoEvent}`;
                        }
                        return <div>
                            <p style={{margin:0,whiteSpace:'normal'}} data-tip={strTip}>

                                {arg.event.extendedProps.otherUser?
                                    <div className='p-1'>{arg.event.title}</div>
                                    :
                                    <div className='p-1' style={{cursor:'pointer'}}>{arg.event.extendedProps.statusID==3?<CgSandClock/>:<BsCheckAll/>} {arg.event.title}</div>
                                }
                            </p>
                            <ReactTooltip multiline={true} />
                        </div>
                    }}
                />
            </div>

            {/*ฟอร์มการจองห้องประชุม*/}
            <Modal size="lg" show={show} onHide={() => {
                setActivity('');
                setContact('');
                setDescription('');
                setTimeStart('08:30')
                setTimeEnd('16:30')
                setShow(false)
            }}>
                <Modal.Header>
                    <Modal.Title>
                        <h5><b>การจอง{currentRoom && currentRoom.name}</b></h5>
                        <h6 style={{ fontWeight: 'bold' }}>วันที่ {moment(currentDate).format('DD/MM/YYYY')}</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form id="form1" onSubmit={submit}>
                        <Form.Group>
                            <Form.Label>ชื่อกิจกรรม <span style={{color:"red"}}> * </span></Form.Label>
                            <Form.Control required placeholder="" value={activity} onChange={(e)=>{
                                setActivity(e.target.value);
                            }}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>เวลาเริ่ม <span style={{color:"red"}}> * </span></Form.Label>
                            <div>
                                <TimePicker
                                    required
                                    onChange={setTimeStart}
                                    value={timeStart}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>เวลาสิ้นสุด <span style={{color:"red"}}> * </span></Form.Label>
                            <div>
                            <TimePicker
                                required
                                onChange={(time)=>{
                                    console.log(time);
                                    setTimeEnd(time)
                                }}
                                value={timeEnd}
                            />
                            </div>
                        </Form.Group>

                        {/*<Form.Group>*/}
                        {/*    <Form.Label>ประเภทการใช้งาน <span style={{color:"red"}}> * </span></Form.Label>*/}
                        {/*    <Form.Control as="select" value={selectedReason} onChange={(e)=>{*/}
                        {/*        setSelectedReason(e.target.value);*/}
                        {/*    }}>*/}
                        {/*        <option value="none">- โปรดเลือกประเภท -</option>*/}
                        {/*        {*/}
                        {/*            reason.map((r)=>{*/}
                        {/*                return(*/}
                        {/*                    <option key={r.id} value={r.id}>{r.name}</option>*/}
                        {/*                )*/}
                        {/*            })*/}
                        {/*        }*/}
                        {/*    </Form.Control>*/}
                        {/*</Form.Group>*/}

                        <Form.Group>
                            <Form.Label>เบอร์ติดต่อ (เบอร์สำนักงาน หรือ เบอร์โทรศัพท์) <span style={{color:"red"}}> * </span></Form.Label>
                            <Form.Control required placeholder="" value={contact} onChange={(e)=>{
                                setContact(e.target.value);
                            }}/>
                            <Form.Text muted>
                                * ระบุตัวเลข 5 ตัวขึ้นไปเท่านั้น และไม่ต้องใส่ขีด (-) หรือการเว้นวรรค
                            </Form.Text>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>รายละเอียดเพิ่มเติม</Form.Label>
                            <Form.Control as="textarea" rows={2} placeholder="" value={description} onChange={(e)=>{
                                setDescription(e.target.value);
                            }}/>
                        </Form.Group>
                        <Form.Group>
                            {/*<div><Form.Label><span style={{color:"red"}}> * </span>There are required fields in this form marked</Form.Label></div>*/}
                            <div><Form.Label><span style={{color:"red"}}> * </span>กรุณาจองห้องล่วงหน้าอย่างน้อย 2 วันทำการ</Form.Label></div>
                            <div><Form.Label><span style={{color:"red"}}> * </span>หากต้องการจองห้องสำหรับใช้งานติดต่อกันหลายวัน รบกวนติดต่อล่วงหน้าที่ <span style={{color:"red"}}> Email : ltic.psli@kku.ac.th </span></Form.Label></div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit" form="form1">
                        จองห้อง
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setShow(false)
                    }}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default Booking;
